import React from 'react';
import PropTypes from 'prop-types';
import { Chip, Tooltip, Typography } from '@mui/material';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import { formatWorkingHours } from '../workingHours';

export function WorkingHoursSummary({ workingHours }) {
  const lines = formatWorkingHours(workingHours);
  if (lines.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        Não definidos
      </Typography>
    );
  }
  return lines.map((line) => (
    <Typography key={line} variant="body2" color="text.secondary">
      {line}
    </Typography>
  ));
}

WorkingHoursSummary.propTypes = {
  workingHours: PropTypes.arrayOf(
    PropTypes.shape({
      dayOfWeek: PropTypes.string,
      intervals: PropTypes.arrayOf(
        PropTypes.shape({ start: PropTypes.string, end: PropTypes.string }),
      ),
    }),
  ),
};

WorkingHoursSummary.defaultProps = {
  workingHours: [],
};

export function DigitalCertificateStatus({ fileName, uploadedAt, label }) {
  if (!fileName) {
    return <Chip size="small" variant="outlined" label={label ? `Sem ${label}` : 'Não possui'} />;
  }
  return (
    <Tooltip title={uploadedAt ? `${fileName} · enviado em ${uploadedAt}` : fileName}>
      <Chip
        size="small"
        color="success"
        variant="outlined"
        icon={<VerifiedUserOutlinedIcon />}
        label={label ? `Com ${label}` : 'Possui'}
      />
    </Tooltip>
  );
}

DigitalCertificateStatus.propTypes = {
  fileName: PropTypes.string,
  uploadedAt: PropTypes.string,
  // When informed, the chip describes itself (e.g. "Com certificado digital"), for layouts without a column header.
  label: PropTypes.string,
};

DigitalCertificateStatus.defaultProps = {
  fileName: null,
  uploadedAt: null,
  label: null,
};
